"use strict";

exports.__esModule = true;
var _stylesDefinition = require("./stylesDefinition");
Object.keys(_stylesDefinition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _stylesDefinition[key]) return;
  exports[key] = _stylesDefinition[key];
});
var _settingsDefinition = require("./settingsDefinition");
Object.keys(_settingsDefinition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _settingsDefinition[key]) return;
  exports[key] = _settingsDefinition[key];
});
var _variants = require("./variants");
Object.keys(_variants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _variants[key]) return;
  exports[key] = _variants[key];
});
//# sourceMappingURL=index.js.map